// 可見性規則（對應規格書 3.3）：
// private 只有建立者看得到 / trip 所有成員看得到 / public 所有人看得到。
//
// 規格書明確要求「可見性過濾必須在伺服器端的每一個查詢中執行，不能只依賴前端隱藏」。
// 這個 demo 沒有後端，所以把過濾邏輯集中寫在這一個檔案，
// 所有列表型的 getter 都必須呼叫 filterVisible()，模擬「伺服器只回傳你有權限看到的資料」，
// 而不是在畫面上用 v-if 藏起來而已（畫面上仍會另外用 VisibilityTag 顯示標籤，但資料本身已經被濾掉）。

export const VISIBILITY_LABELS = {
  private: { text: '只有我', icon: '🔒' },
  trip: { text: '旅伴', icon: '👥' },
  public: { text: '公開', icon: '🌍' }
}

function ownerOf (item) {
  return item.creatorId || item.createdBy || item.assigneeId || null
}

export function canView (item, viewerId) {
  if (!item) return false
  if (item.visibility === 'public') return true
  if (item.visibility === 'trip') return !!viewerId
  if (item.visibility === 'private') return viewerId && ownerOf(item) === viewerId
  return true
}

export function filterVisible (list, viewerId) {
  return (list || []).filter(item => canView(item, viewerId))
}
